import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import { Button } from "@mui/material";
import { NumericFormat } from 'react-number-format';
import QuoteCard from './QuoteCard'
import { getCancerDisclaimers, getAccidentDisclaimers, getCriticalIllnessDisclaimers, getCancerDisabled, getCriticalIllnessDisabled } from './Disclaimers';
import { getCancerBrochure, getAccidentBrochure, getCriticalIllnessBrochure } from '../Helpers/Brochures';

export default function QuoteResults(props) {

  const [cardActive, setCardActive] = useState([false, false, false]);
  const [selectedQuote, setSelectedQuote] = useState([]);
  const [quoteCardData, setQuoteCardData] = useState([
    {
      title: 'Cancer Protection',
      productName: 'Cancer Protection',
      product: 'cancer',
      iconUrl: '/product-landing/supp/cancer-ribbon.png',
      monthlyRate: null,
      disclaimers: null,
      disabled: true,
      disclaimersFunction: getCancerDisclaimers,
      isDisabledFunction: getCancerDisabled,
      getBrochure: getCancerBrochure
    },
    {
      title: 'Accident Advantage',
      productName: 'Accident Advantage',
      product: 'accident',
      iconUrl: '/product-landing/supp/ambulence.png',
      monthlyRate: null,
      disclaimers: null,
      disabled: true,
      disclaimersFunction: getAccidentDisclaimers,
      isDisabledFunction: () => { return false },
      getBrochure: getAccidentBrochure
    },
    {
      title: "Critical\nIllness",
      productName: 'Critical Illness',
      product: 'critical-illness',
      iconUrl: '/product-landing/supp/heartbeat.png',
      monthlyRate: null,
      disclaimers: null,
      disabled: true,
      disclaimersFunction: getCriticalIllnessDisclaimers,
      isDisabledFunction: getCriticalIllnessDisabled,
      getBrochure: getCriticalIllnessBrochure
    }
  ]);


  const downloadPDF = (product, filename) => {
    const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

    fetch(`${covrServicesUrl}/api/Aflac/GetPDF?product=${product}&filename=${filename}`)
      .then(response => {
        response.blob().then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `aflac-${product}.pdf`;
          a.click();
        });
      });
  }

  const productDetailsOnClick = (state, getBrochure, product) => {
    var brochure = getBrochure(state);
    if (brochure) {
      if (brochure.download) {
        downloadPDF(product, brochure.filename);
      } else {
        window.open(brochure.url, '_blank');
      }
    }
  }
  useEffect(() => {
    props.handleSelectedQuote(selectedQuote);
  }, [selectedQuote])
  const flipCardActive = (index) => {
    var newCardActive = [];
    var selected1 = false;
    var products = [];
    setSelectedQuote([]);
    cardActive.forEach((value, i) => {
      if (index === i) {
        newCardActive.push(!value);
        selected1 = selected1 || !value;
        if (!value) {
          products.push(quoteCardData[i].productName);
          setSelectedQuote((r)=>[...r,quoteCardData[i]]);
        }
      } else {
        newCardActive.push(value);
        selected1 = selected1 || value;
        if (value) {
          products.push(quoteCardData[i].productName);
          setSelectedQuote((r)=>[...r,quoteCardData[i]]);
        }
      }
    });
    props.setSelected(selected1);
    setCardActive(newCardActive);
    var productString = undefined;
    if (products.length > 0) {
      productString = '';
      products.forEach((p, i) => {
        productString = productString.concat(p);
        if (products.length > 1 && i !== products.length - 1) {
          if (i === products.length - 2) {
            productString = productString.concat(' & ');
          } else {
            productString = productString.concat(', ');
          }
        }
      })
    }
    props.onFieldChange('specialNote', productString);
  }

  useEffect(() => {
    if (!props.quoteResults || !props.quoteResults.length) return;
    var productInfo = [];
    quoteCardData.forEach(d => {
      var rate = undefined;
      var disclaimers = undefined;
      var disabled = true;
      props.quoteResults.forEach(q => {
        if (q.productName.toLowerCase().indexOf(d.productName.substring(0, 5).toLowerCase()) >= 0) {
          disabled = d.isDisabledFunction(props.state);
          disclaimers = d.disclaimersFunction(props.state);
          if (!disabled) {
            rate = q.individualLowestPremium;
          }
        }
      });
      productInfo.push({ rate: rate, disclaimers: disclaimers, disabled: disabled });
    }
    )
    var qcd = quoteCardData;
    productInfo.forEach((p, i) => {
      qcd[i].monthlyRate = p.rate;
      qcd[i].disclaimers = p.disclaimers;
      qcd[i].disabled = p.disabled;
    }
    );
    setQuoteCardData(qcd);
  }, [props.quoteResults]);

  useEffect(() => {
    if (!props.quoteResults) {
      return;
    }
    var total = 0;
    quoteCardData.forEach((data, i) => {
      if (cardActive[i] && data.monthlyRate) {
        total += data.monthlyRate;
      }
    });
    props.onFieldChange('premium', total || null);
  }, [cardActive]);
  
  useEffect(() => {
    setCardActive([false, false, false]);
  }, [props.loading]);

  return (
    <div id="aflac-quote-results" className="aflac-quote-results shadow-sm px-3">
      <Row className="quote-row">
        {quoteCardData.map((data, index) =>
          <Col key={index} md={4} className="mt-3 card-wrapper w-100">
            <QuoteCard
              title={data.title}
              iconUrl={data.iconUrl}
              monthlyRate={data.monthlyRate}
              productDetailsOnClick={() => productDetailsOnClick(props.state, data.getBrochure, data.product)}
              disclaimers={data.disclaimersFunction(props.state)}
              disabled={props.loading || data.disabled}
              active={cardActive[index]}
              flipActive={() => flipCardActive(index)}
              loading={props.loading}
            />
          </Col>
        )}
      </Row>
      <Row className="mt-3">
        <Col md>
          <h3 className="text-start">Estimated rates based on individual plans.</h3>
          <p>Select the types of supplemental insurance policies you would like included in your plan. Read more about the requirements for each type of product with the product details links above. A licensed expert will assist in choosing the right benefit plan for you, your spouse, or your family.</p>
        </Col>
        <Col md={3}>
          <h3 className="text-start">{!props.loading && props.formState.premium ? <span><NumericFormat
            className="quote-amount-dollars"
            value={props.formState.premium}
            displayType={'text'}
            thousandSeparator={true}
            decimalScale={2}
            fixedDecimalScale={true}
          />
            <span className="quote-amount-mo"> /mo</span>
          </span>
            :
            <span className="dots">...</span>}
          </h3>
          <p>Estimated total cost</p>
          <Button type="submit" variant="contained" color="primary" className="mb-3">Continue</Button>
          {props.error && props.error ?
            <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error d-block m-0 px-0">{props.error.message}
            </span>
            : ''}
        </Col>
      </Row>
    </div>
  )
}

QuoteResults.propTypes = {
  state: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  quoteResults: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object
}
